import React from 'react';
import MfsContent from '../../views/MfsContent';

const SeoDashboard = () => {
  return <MfsContent />;
};

export default SeoDashboard;
